import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React from "react";
import CustomCarousel from "Root/profile/components/common/Carousel";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import styles from "./style.module.css";
const AccountCartSection = ({ children, carouselSettings = {} }) => {
    const screenWidth = useScreenWidth();
    const xsm = screenWidth <= 330;
    const sm = screenWidth <= 568;
    const md = screenWidth > 568 && screenWidth <= 768;
    const lg = screenWidth > 768 && screenWidth <= 1024;
    const xlg = screenWidth > 1024;
    const showCarousel = () => {
        const childrenLength = React.Children.toArray(children).length;
        if (xsm && childrenLength >= 2) {
            return true;
        }
        if (sm && childrenLength > 2) {
            return true;
        }
        if (md && childrenLength >= 4) {
            return true;
        }
        if (lg && childrenLength >= 3) {
            return true;
        }
        if (xlg && childrenLength >= 4) {
            return true;
        }
        return false;
    };
    const getSlidesToShow = () => {
        const width = screenWidth;
        if (width > 1384) {
            return 3.6;
        }
        if (width > 1260 && width <= 1384) {
            return 3.3;
        }
        if (width > 1038 && width <= 1260) {
            return 3;
        }
        if (width > 768 && width <= 1038) {
            return 2.3;
        }
        if (width > 700 && width <= 768) {
            return 4;
        }
        if (width > 500 && width <= 700) {
            return 3.1;
        }
        if (width > 410 && width <= 500) {
            return 2.5;
        }
        if (width >= 330 && width < 410) {
            return 2;
        }
        if (width >= 280 && width < 330) {
            return 1.5;
        }
        return 2;
    };
    return (_jsx("div", { className: styles.account_cart_section_mob, children: showCarousel() ? (_jsx(CustomCarousel, { extraSettings: {
                initialSlide: 0,
                slidesToShow: carouselSettings.slidesToShow || getSlidesToShow(),
                slidesToScroll: 1,
                swipeToSlide: true,
                infinite: false,
                dots: false,
                arrows: false,
                ...carouselSettings,
            }, className: React.Children.toArray(children).length > 2 ? styles.carouselwide : styles.carousel, children: children })) : (_jsx("div", { className: styles.account_cart_no_carousel, children: children })) }));
};
export default AccountCartSection;
